import * as Icons from "heroicons-react";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  addProductPrice,
  handleMrp,
  handleRemove,
  handleSupplier,
  handleTp,
  handleWarehouse,
  productPriceList,
} from "../../../features/ProductpriceListSlice";
import {
  useAddPriceMutation,
  useAsyncPriceMutation,
  useDeletePriceMutation,
  // useCreateInventoryMutation,
  usePriceByProductQuery,
  useUpdatePriceMutation,
} from "../../../services/priceApi";
import { signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
import SupplierSelectByProduct from "../CustomSelect/SupplierSelectByProduct";
import WareHouseDW from "../CustomSelect/WareHouseDW";
import LoadingModal from "./LoadingModal";
import "./ProductPriceModal.css";
// import { selectIsUpdate, selectPriceId } from "../../../features/priceUpdateSlice";

const ProductPriceModal = ({ show, handleClose, productId }) => {
  const dispatch = useDispatch();
  const priceTable = useSelector((state) => state.productPriceListReducer);
  const [addPrice] = useAddPriceMutation();
  const [updatePrice] = useUpdatePriceMutation();
  const [updateDeletePrice] = useDeletePriceMutation();
  // const [createPriceInventory] = useCreateInventoryMutation();
  const [asyncPrice] = useAsyncPriceMutation();

  const [loader, setLoader] = useState(true);
  const [warehouse, setWarehouse] = useState("allWh");
  const handleLoaderClose = () => setLoader(false);
  let i = 1;

  // const [priceTable, setPriceTable] = useState([]);

  const { data, isLoading, isSuccess, refetch } =
    usePriceByProductQuery(productId);
  // console.log("data", data);
  // warehouse
  const auth = signInUser();

  useEffect(() => {
    refetch();
  }, [warehouse]);

  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, []);

  // console.log("Warehouse", warehouse);

  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  useEffect(() => {
    if (data) {
      dispatch(productPriceList([]));
      setLoader(true);
      refetch();
    }
  }, [productId]);

  useEffect(() => {
    if (data) {
      dispatch(productPriceList(data.priceTable));
      setLoader(false);
    }
  }, [isSuccess, data]);

  // console.log("Data", data);
  // console.log("Price", priceTable);

  // OPERATIONS
  //onSyncPrice (Save button)
  const onSyncPrice = async () => {
    try {
      // Check if there are any new prices without _id
      const unsavedPrices = priceTable.filter((item) => !item._id);
      if (unsavedPrices.length > 0) {
        for (const item of unsavedPrices) {
          if (!item?.supplier || item?.supplier === "") {
            notify("Please select a vendor/supplier for the new price.", "error");
            return;
          }
          const warehouseVal =
            item?.warehouse && item?.warehouse !== "no-warehouse"
              ? item.warehouse
              : (auth?.warehouse?._id || auth?.warehouse || undefined);

          let priceData = {
            article_code: productId,
            supplier: item.supplier,
            warehouse: warehouseVal,
            tp: Number(item.tp) || 0,
            mrp: Number(item.mrp) || 0,
            order: item.order || "",
            status: item.status || "active",
            aamarId: auth?.aamarId || "",
          };
          await addPrice(priceData).unwrap();
        }
      }

      await asyncPrice({ productId: productId }).unwrap();
      await refetch();
      notify("Prices Saved Successfully", "success");
    } catch (err) {
      console.error("Error saving prices:", err);
      notify(
        err?.data?.message || err?.message || "Failed to save prices.",
        "error"
      );
    }
  };

  //handleVendorChange
  const handleVendorChange = (index, e) => {
    // console.log("e", e, "index,", index);
    dispatch(
      handleSupplier({
        supplier: e.option,
        index: index,
      })
    );
  };

  //handleCustomTp
  const handleCustomTp = (e, index) => {
    dispatch(
      handleTp({
        tp: e.target.value,
        index: index,
      })
    );
  };

  //handleCustomMrp
  const handleCustomMrp = (e, index) => {
    dispatch(
      handleMrp({
        mrp: e.target.value,
        index: index,
      })
    );
  };

  //handleWhChange
  const handleWhChange = (e) => {
    if (e && e?.option && typeof e?.index !== "undefined") {
      dispatch(
        handleWarehouse({
          warehouse: e.option,
          index: e.index, // Ensure e.index is correctly passed.
        })
      );
    } else {
      console.error("Invalid event data:", e);
    }
  };

  //addNewPrice
  const addNewPrice = async (item, index) => {
    if (!item?.supplier || item?.supplier === "") {
      notify("Please select a vendor/supplier.", "error");
      return;
    }

    const warehouseVal =
      item?.warehouse && item?.warehouse !== "no-warehouse"
        ? item.warehouse
        : (auth?.warehouse?._id || auth?.warehouse || undefined);

    let priceData = {
      article_code: productId,
      supplier: item.supplier,
      warehouse: warehouseVal,
      tp: Number(item.tp) || 0,
      mrp: Number(item.mrp) || 0,
      order: item.order || "",
      status: item.status || "active",
      aamarId: auth?.aamarId || "",
    };

    try {
      const res = await addPrice(priceData).unwrap();
      if (res) {
        notify("New Price Created Successfully", "success");
        await refetch();
      }
    } catch (err) {
      console.error("Error creating price:", err);
      notify(
        err?.data?.message || err?.message || "Failed to create price.",
        "error"
      );
    }
  };

  //removeAddNew
  const removeAddNew = (index) => {
    // console.log(index);

    dispatch(handleRemove(index));
  };

  //handleAddPrice
  const handleAddPrice = () => {
    const defaultWh =
      warehouse !== "allWh" && warehouse !== "no-warehouse"
        ? warehouse
        : (auth?.warehouse?._id || auth?.warehouse || "");
    dispatch(addProductPrice({ warehouse: defaultWh }));
  };

  //handlePriceStatus
  const handlePriceStatus = async (item) => {
    try {
      const data = {
        _id: item._id,
        status: item.status === "active" ? "inactive" : "active",
      };
      await updatePrice(data).unwrap();
      notify("Status Change Successful.", "success");
      await refetch();
    } catch (err) {
      console.error("Error updating price status:", err);
      notify(
        err?.data?.message || err?.message || "Failed to change status.",
        "error"
      );
    }
  };

  const deleteHandler = async (id) => {
    const result = await Swal.fire({
      title: "Are you Sure?",
      text: "Delete this Price?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await updateDeletePrice(id).unwrap();
        notify("Price Deleted Successfully.", "success");
        await refetch();
      } catch (err) {
        console.error("Error deleting price:", err);
        notify(
          err?.data?.message || err?.message || "Failed to delete price.",
          "error"
        );
      }
    }
  };

  //handleUpdatePrice
  const handleUpdatePrice = async (item) => {
    try {
      const warehouseVal =
        item?.warehouse && item?.warehouse !== "no-warehouse"
          ? item.warehouse
          : (auth?.warehouse?._id || auth?.warehouse || undefined);

      const updateData = {
        _id: item._id,
        supplier: item.supplier,
        warehouse: warehouseVal,
        tp: Number(item.tp) || 0,
        mrp: Number(item.mrp) || 0,
        status: item.status,
      };
      await updatePrice(updateData).unwrap();
      notify("Price Update Success", "success");
      await refetch();
    } catch (err) {
      console.error("Error updating price:", err);
      notify(
        err?.data?.message || err?.message || "Failed to update price.",
        "error"
      );
    }
  };

  return (
    <>
      <LoadingModal
        title={"Please Wait"}
        onShow={loader}
        handleClose={handleLoaderClose}
      ></LoadingModal>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        backdrop="static"
        keyboard={false}
        className=""
      >
        <Modal.Header closeButton>
          <Modal.Title>Product Price Table</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-start">
          <div className="mx-auto">
            {/* <Card className="text-center"> */}
            <div className="">
              <div className="row mb-3 justify-content-center align-content-center">
                <p className=" col-md-6">
                  <b>Product Name: </b>
                  {data && data?.name}
                </p>
                <div className=" col-md-6">
                  {/* {auth?.type === "admin" && (
                    <WareHouseDW
                      id="warehouse"
                      name="warehouse"
                      handleOnChange={handleOnchangeWareHouseFrom}
                      className="form-control"
                      style={{ width: "20%" }}
                    />
                  )} */}
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <span>
                  <b>EAN:</b> {data && data?.ean}
                </span>
                <span>
                  <b>Category:</b> {data && data?.category}
                </span>
                <span>
                  <b>MC:</b> {data && data?.master_category}
                </span>
                <span>
                  <b>Code:</b> {data && data?.article_code}
                </span>
              </div>
              <hr />
              <div className="table-responsive-sm">
                <table className="table table-striped ">
                  <thead className="container">
                    <tr className="row m-0">
                      <th className="col-md-1 text-center">#</th>
                      <th className="col-md-2 text-center">Vendor</th>
                      <th className="col-md-3 text-center">WH</th>
                      <th className="col-md-2 text-center">TP</th>
                      <th className="col-md-2 text-center">MRP</th>
                      {/* <th className="col-md-1 text-center">Stock</th> */}
                      <th className="col-md-2 text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="container">
                    {priceTable.length > 0 &&
                      priceTable.map((item, index) => (
                        <tr className="row m-0" key={index}>
                          <th className="col-md-1 text-center">{i++}</th>
                          <td className="col-md-2">
                            <SupplierSelectByProduct
                              article_code={data && data?.article_code}
                              handleOnChange={handleVendorChange}
                              className={item.order}
                              name={index}
                              value={item?.supplier}
                              style={{ width: "60px" }}
                            />
                          </td>
                          <td className="col-md-3">
                            <div
                              className="mt-2 mt-md-0 mb-2 mb-md-0 "
                              style={{
                                width:
                                  window.innerWidth >= 1024
                                    ? 190
                                    : window.innerWidth >= 768
                                    ? 180
                                    : "100%", // Adjust width based on screen size
                              }}
                            >
                              <WareHouseDW
                                handleOnChange={handleWhChange}
                                name={index}
                                warehouse={item?.warehouse}
                              />
                            </div>
                          </td>
                          <td className="col-md-2 ">
                            <input
                              className="form-control"
                              onChange={(e) => handleCustomTp(e, index)}
                              value={item?.tp !== undefined && item?.tp !== null ? item.tp : ""}
                              type="number"
                            />
                          </td>
                          <td className="col-md-2">
                            <input
                              className="form-control"
                              onChange={(e) => handleCustomMrp(e, index)}
                              value={item?.mrp !== undefined && item?.mrp !== null ? item.mrp : ""}
                              type="number"
                              style={{ minWidth: "100px" }}
                            />
                          </td>
                          {/* <td className="col-md-1 text-center">
                            {item.stock !== null
                              ? parseFloat(item.stock)?.toFixed(2)
                              : 0}
                          </td> */}
                          <td className="col-md-2 text-end">
                            <div className="d-flex justify-content-center align-items-center">
                              <Form.Check
                                type="switch"
                                checked={
                                  item?.status === "active" ? "checked" : ""
                                }
                                onChange={() => handlePriceStatus(item)}
                                label=""
                              />
                              {item?._id ? (
                                <>
                                  <Icons.CheckCircleOutline
                                    className="icon-eye"
                                    color={"green"}
                                    onClick={() => handleUpdatePrice(item)}
                                  />
                                  {/* {item.stock !== null ? ( */}
                                  <Icons.TrashOutline
                                    title="Inventory"
                                    className="icon-trash"
                                    onClick={() => deleteHandler(item?._id)}
                                  />

                                  {/* ) : (
                                    <Icons.ArchiveOutline
                                      title={"No Inventory"}
                                      className="icon-edit"
                                      color={"tomato"}
                                      onClick={() => createInventory(item._id)}
                                    />
                                  )} */}
                                </>
                              ) : (
                                <>
                                  <Icons.CheckCircleOutline
                                    className="icon-eye pr-3 text-gray hover:text-success"
                                    onClick={() => addNewPrice(item, index)}
                                  />
                                  <Icons.XCircleOutline
                                    className="icon-trash text-gray hover:text-danger"
                                    onClick={() => removeAddNew(index)}
                                  />
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}

                    {/* <td>BDT</td> */}
                  </tbody>
                </table>
              </div>
            </div>
            {/* </Card> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-outline-dark float-end"
            onClick={() => handleAddPrice(productId)}
          >
            + New Price
          </button>
          <Button
            onClick={onSyncPrice}
            variant="dark"
            className="d-flex align-items-center justify-content-center "
          >
            <Icons.Save size={18} className="me-2" />
            Save
          </Button>
          <Button
            onClick={handleClose}
            variant="dark"
            className="d-flex align-items-center justify-content-center"
          >
            <Icons.X size={18} className="me-2" />
            Close
          </Button>

          <Toaster position="bottom-right" />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProductPriceModal;
